export default __webpack_public_path__ + "static/media/export.7d65cd88.svg";